// extracted by css-extract-rspack-plugin
export default {"root":"mj0Xd","titleBlock":"C50qK","chartBlock":"iERS2","yAxis":"lihBK","chartCanvas":"y4LYt","chartSilhouette":"rXs_B","chartArea":"LNwN0","chartLine":"iqcsu"};